<template>
  <tbody>
  <tr v-if="details.personal_data">
    <td><label>{{ $t('accountAdditionalDetails.details.personal_data') }}</label></td>
    <td>
      <person-data :details="details.personal_data"/>
    </td>
  </tr>
  <tr v-if="details.contacts">
    <td><label>{{ $t('accountAdditionalDetails.details.contacts') }}</label></td>
    <td>
      <contacts :details="details.contacts"/>
    </td>
  </tr>
  <tr v-if="details.assignee">
    <td><label>{{ $t('accountAdditionalDetails.details.assignee') }}</label></td>
    <td>
      <assignee :details="details.assignee"/>
    </td>
  </tr>
  <tr v-if="details.document">
    <td><label>{{ $t('accountAdditionalDetails.details.document') }}</label></td>
    <td>
      <document :details="details.document"/>
    </td>
  </tr>
  </tbody>
</template>
<script>
import PersonData from './DataViewPersonData'
import Contacts from './DataViewContacts'
import Assignee from './DataViewAssignee'
import Document from './DataViewDocument'

export default {
  name: 'AccountAdditionalDetailsDataView',
  components: {
    PersonData,
    Contacts,
    Assignee,
    Document
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  computed: {}
};
</script>
<style></style>
